export const form = {
  formCopyLink: '링크 복사',
  formLinkCopied: '링크가 복사되었습니다!'
}
